import { useAPIAction, DesignCollectionsDraftApi } from "melco-shared-logic";

export const useAddDesignCollection = () =>
  useAPIAction(
    DesignCollectionsDraftApi,
    async (api) => {
      const data = await api.userDesignCollectionsCreateDraft({
        sharedserviceMelcoModelsCreateDesignCollection: {
          design_list: [],
        },
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "libraries.design_collections.actions.add",
    }
  );
